import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";

/** Shared duration words for the archive page and its browser index. */
export class AppElapsedDays {
    public static Words = (Days: number, FaultName: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (Days <= 0) { return "today"; }
            if (Days === 1) { return "1 day"; }
            if (Days < 60) { return String(Days) + " days"; }
            if (Days < 730) { return String(Math.round(Days / 30)) + " months"; }
            return String(Math.round(Days / 365)) + " years";
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, FaultName);
            return "";
        }
    };
}
